import { createRoot } from 'react-dom/client';
import * as React from 'react';
import './styles.css';
import App from './App';

createRoot(document.getElementById('root') as HTMLElement).render(<App />);